import React from 'react';
import { StarIcon } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  const revealRef = useScrollReveal();
  return <section ref={revealRef} aria-labelledby="referencie-nadpis" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-475" data-mp="1r1ds1zo4qgvq">
      <div className="reveal text-center max-w-3xl mx-auto mb-14 md:mb-20" data-id="element-476" data-mp="1d0jl7lgqcnz6">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-4" data-id="element-477" data-mp="1i1qtdlmsbp6d">Referencie</p>
        <h2 id="referencie-nadpis" className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-5" data-id="element-478" data-mp="142r3ybrg7695">
          Čo hovoria naši klienti
        </h2>
        <p className="text-lg md:text-xl text-apple-gray leading-relaxed" data-id="element-479" data-mp="2yfz2oeijo202">
          Skúsenosti firiem, ktoré už používajú naše PWA a AI riešenia.
        </p>
      </div>

      <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-480" data-mp="2v0j3vj58zswm">
        {testimonials.map((t, index) => <li key={t.name} className={`reveal reveal-delay-${index + 1}`} data-id="element-481" data-mp="2q1pxeaodp25y" data-mpi={index}>
            <Card className="h-full border border-gray-200 rounded-3xl bg-white shadow-sm" data-id="element-482" data-mp="34rniuiuxbdrg">
              <CardContent className="p-6 md:p-10 flex flex-col h-full" data-id="element-483" data-mp="2zs14u779tthl">
                <figure className="flex flex-col h-full" data-id="element-484" data-mp="2c2qdfgbt9bg4">
                  <div className="flex gap-1 mb-5" role="img" aria-label="Hodnotenie 5 z 5" data-id="element-485" data-mp="2c38fitl5mjvy">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-4 h-4 fill-current text-amber-500" aria-hidden="true" data-id="element-486" data-mp="2m0mm81h9zub2" />)}
                  </div>
                  <blockquote className="text-apple-black text-lg leading-relaxed mb-8 flex-grow" data-id="element-487" data-mp="2h08e6jfockd1">
                    „{t.quote}"
                  </blockquote>
                  <figcaption className="flex items-center gap-4 pt-6 border-t border-gray-100" data-id="element-488" data-mp="3shrlamwdl7gv">
                    <img src={t.image} alt="" width={48} height={48} loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover" data-id="element-489" data-mp="3faf0sjtxbu9" />
                    <div data-id="element-490" data-mp="iaqc76fphnuv">
                      <p className="font-bold text-apple-black text-sm" data-id="element-491" data-mp="i9yosiw9iwfo">{t.name}</p>
                      <p className="text-apple-gray text-sm" data-id="element-492" data-mp="3gv87ql81cvvq">
                        {t.role}, {t.company}
                      </p>
                    </div>
                  </figcaption>
                </figure>
              </CardContent>
            </Card>
          </li>)}
      </ul>
    </section>;
}